<template>
  <div>

    <div class="mt-5 mb-5">
      <v-row dense>
        <v-col v-for="card in stats" :key="card.title" cols="12" md="3" sm="6" class="d-flex">
          <StatsCard class="flex-grow-1" :title="card.title" :value="card.value" :icon="card.icon" :color="card.color"
            :caption="card.caption" />
        </v-col>
      </v-row>
    </div>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <span class="v-das-title-font">รายการข้อมูล Activity</span>
            <v-spacer />
            <v-autocomplete style="max-width: 200px !important" :items="years" v-model="selectYear" dense
              label="เลือกดูข้อมูลตามรอบการประเมิน PA" filled persistent-hint hint=""></v-autocomplete>
          </v-card-title>

          <div class="pa-5">
            <v-row class="mb-3" dense>
              <v-col cols="auto" v-for="option in filterOptions" :key="option.value">
                <v-checkbox v-model="selectedFilters" :label="option.label" :value="option.value" color="primary"
                  hide-details></v-checkbox>
              </v-col>
            </v-row>

            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search ... " single-line hide-details filled
              dense></v-text-field>

            <v-data-table class="table-bordered" :headers="headers" :items="filteredData" :search="search"
              :loading="loading" :custom-filter="customSearch">
              <template v-slot:item.status="{ item }">
                <v-chip :color="getStatusColor(item.status)" small dark label class="text-capitalize font-weight-bold">
                  {{ item.status }}
                </v-chip>
              </template>
              <template v-slot:item.name_academic="{ item }">

                <div class="text-left">
                  <p style="font-weight: 800;font-size: 16px;" class="deep-purple--text mt-2 mb-2">
                    {{ item.name_academic }}
                  </p>

                  <p v-if="item.muic_account_aj" class="mb-2">
                    <span>InstructorCode :</span> {{ item.muic_account_aj.username }}
                  </p>

                  <div>
                    <span>Start:</span>&nbsp;&nbsp;
                    {{ formatThaiDate(item.date_start) }}
                  </div>

                  <div class="mb-2">
                    <span>End:</span>&nbsp;&nbsp;
                    <span class="highlight-end red--text font-weight-bold"> {{ formatThaiDate(item.date_end) }} </span>
                  </div>

                  <!--  
                    <div class="mb-2">
                    <span>Year:</span>&nbsp;&nbsp;
                    {{ item.year_academic }}
                  </div>
                  -->
                </div>

              </template>

              <template v-slot:item.history="{ item }">
                <v-list-item three-line>
                  <v-list-item-content>
                    <v-list-item-subtitle v-if="['reject', 'rejected'].includes(item.status)" class="red--text">
                      Remark : {{ item.status_remark }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      <p class="mt-0 mb-0">Update at : {{ formatThaiDateTime(item.updated_at) }}</p>
                      <p class="mt-0 mb-0">Create at : {{ formatThaiDateTime(item.created_at) }}</p>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>


              <template v-slot:item.action="{ item }">
                <div class="action-buttons">
                  <v-btn color="blue" elevation="15" icon small @click="openDetail(item)">
                    <v-icon small dense>mdi-pencil</v-icon>
                  </v-btn>
                </div>
              </template>

            </v-data-table>

          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-navigation-drawer v-model="showDetail" right temporary fixed width="1000">
      <v-sheet class="pa-4" color="grey lighten-4" height="100%">
        <v-toolbar flat dense>
          <v-toolbar-title class="font-weight-bold">Activity Detail</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDetail">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <SheetData :selectedActivity="selectedActivity" @approve="checkActivity" @undo="checkActivity"
          @reject="rejectActivity"></SheetData>
      </v-sheet>
    </v-navigation-drawer>

  </div>
</template>

<script>
import StatsCard from '@/components/CardSummary.vue'
import SheetData from '@/components/SheetData.vue';

export default {
  name: 'DashboardView',
  components: { StatsCard, SheetData },
  data: () => ({
    filterOptions: [
      { label: 'Save', value: 'save' },
      { label: 'Sent', value: 'send' },
      { label: 'Approve', value: 'approve' },
      { label: 'Reject', value: 'reject' },
    ],
    selectedFilters: ['send'],
    selectedStatus: null,
    stats: [
      {
        key: 'approve',
        title: 'Active Approved',
        value: 0,
        icon: 'mdi-file-document-check',
        color: 'secondary',
        caption: ''
      },
      {
        key: 'send',
        title: 'Active Items waiting for review',
        value: 0,
        icon: 'mdi-clock-time-eight-outline',
        color: 'info',
        caption: ''
      },
      {
        key: 'reject',
        title: 'Active Items Reject',
        value: 0,
        icon: 'mdi-file-document-remove-outline',
        color: 'accent',
        caption: ''
      },
      {
        key: 'save',
        title: 'Saved (Draft)',
        value: 0,
        icon: 'mdi-content-save',
        color: 'primary',
        caption: ''
      }
    ],
    headers: [
      {
        sortable: false,
        text: "Title",
        value: "name_academic",
        align: "start",
        class: "font-weight-bold  blue-grey darken-3 white--text",
      },
      {
        sortable: false,
        text: "Type",
        value: "activity_type_detail.detail",
        align: "start",
        class: "font-weight-bold  blue-grey darken-3 white--text",
      },
      {
        sortable: false,
        text: "Hours",
        value: "point_activity",
        align: "end",
        class: "font-weight-bold  blue-grey darken-3 white--text",
      },
      {
        sortable: false,
        text: "Point",
        value: "point_activity",
        align: "end",
        class: "font-weight-bold  blue-grey darken-3 white--text",
      },
      {
        sortable: false,
        text: "Status",
        value: "status",
        align: "center",
        class: "font-weight-bold  blue-grey darken-3 white--text",
      },
      {
        sortable: false,
        text: "History",
        value: "history",
        align: "start",
        class: "font-weight-bold blue-grey darken-3 white--text",
      },
      {
        sortable: false,
        text: "",
        value: "action",
        align: "center",
        class: "font-weight-bold blue-grey darken-3 white--text",
      },
    ],

    dataActivity: [],
    loading: false,
    search: '',

    years: [],
    selectYear: null,

    showDetail: false,
    selectedActivity: {}
  }),

  watch: {
    selectYear() {
      this.getAdminActivityList()
    },
  },

  computed: {
    filteredData() {
      let result = this.dataActivity

      // Filter by status checkbox
      if (this.selectedFilters.length > 0) {
        result = result.filter(item =>
          this.selectedFilters.includes(item.type)
        )
      }

      // Filter by single status
      if (this.selectedStatus) {
        result = result.filter(
          item => item.status === this.selectedStatus
        )
      }

      // Filter by PA evaluation period using date_end
      if (this.selectYear) {
        const { start, end } = this.getPaDateRange(this.selectYear)

        result = result.filter(item => {
          if (!item.date_end) return false
          return item.date_end >= start && item.date_end <= end
        })
      }

      return result
    }
  },

  created() {
    // Set selectYear before mounted/watchers to avoid duplicate API calls
    this.getPeriods()
  },
  mounted() {
    this.getAdminActivityList()
  },

  methods: {
    customSearch(value, search, item) {
      if (!search) return true;
      const s = search.toLowerCase();

      // Default value check
      if (value != null && typeof value !== 'boolean' && value.toString().toLowerCase().includes(s)) {
        return true;
      }

      // Deep search for username
      if (item.muic_account_aj && item.muic_account_aj.username && item.muic_account_aj.username.toString().toLowerCase().includes(s)) {
        return true;
      }

      return false;
    },
    formatThaiDate(date) {
      if (!date) return '-'
      return this.$dayjs(date).locale('th').format('D MMMM BBBB')
    },
    formatThaiDateTime(date) {
      if (!date) return '-'
      return this.$dayjs(date).locale('th').format('D MMMM BBBB เวลา HH:mm น.')
    },

    openDetail(item) {
      this.selectedActivity = Object.assign({}, item);
      this.showDetail = true;
    },
    closeDetail() {
      this.showDetail = false;
      this.selectedActivity = Object.assign({}, {});
    },

    statusColor(status) {
      if (status === 'On Track') return 'success'
      if (status === 'At Risk') return 'warning'
      if (status === 'Delayed') return 'error'
      return 'grey'
    },

    getPaDateRange(paYearBE) {
      const yearAD = paYearBE - 543

      return {
        start: `${yearAD - 1}-07-01`,
        end: `${yearAD}-06-30`
      }
    },

    async getPeriods() {
      this.years = [
        { value: null, text: 'ทั้งหมด' }
      ]
      const currentBE = new Date().getFullYear() + 543
      // Show 2 years ahead + current year + last 5 years
      for (let i = -2; i <= 5; i++) {
        const year = currentBE - i
        this.years.push({
          value: year,
          text: `PA ${year}`
        })
      }
      this.selectYear = currentBE
    },

    getStatusColor(status) {
      switch (status) {
        case 'send':
          return 'blue darken-2';
        case 'save':
          return 'amber darken-3';
        case 'approve':
          return 'green darken-2';
        case 'rejected':
          return 'red darken-2';
        default:
          return 'grey darken-1';
      }
    },

    async getAdminActivityList() {
      this.loading = true
      this.dataActivity = []
      try {
        const resData = await this.$http.get(
          // ?year_academic=${this.selectYear}
          `/academic-service/main-activities/`
        )

        if ([200, 201].includes(resData.status)) {
          this.dataActivity = resData.data.map((item) => ({
            ...item,
            type: `${item.status}`,
          }))

          // Reset status counters
          const counter = {
            save: 0,
            send: 0,
            approve: 0,
            reject: 0
          }

          // Count activities by status, filtered by selected year
          let filteredForStats = this.dataActivity
          if (this.selectYear) {
            const { start, end } = this.getPaDateRange(this.selectYear)
            filteredForStats = this.dataActivity.filter(item => {
              if (!item.date_end) return false
              return item.date_end >= start && item.date_end <= end
            })
          }

          filteredForStats.forEach(item => {
            if (counter[item.status] !== undefined) {
              counter[item.status]++
            }
          })

          // Update stats cards (UI updates reactively)
          this.stats = this.stats.map(card => ({
            ...card,
            value: counter[card.key] || 0,
            caption: `updateAt ${this.$dayjs().locale('th').format('D MMM BBBB HH:mm')}`
          }))

        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },

    async checkActivity(...args) {
      try {
        const sendChange = new FormData();
        sendChange.append("status", args[0].textStatus === 'send' ? `send` : 'approve');
        const checkactivity = await this.$http.patch(
          `/academic-service/main-activities/${args[0].data.id}/`,
          sendChange,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (checkactivity.status === 200) {
          const index = this.dataActivity.findIndex(
            (a) => a.id == args[0].data.id
          );
          this.dataActivity[index].status = args[0].textStatus
          this.selectedActivity.status = args[0].textStatus
          this.getAdminActivityList()
        }
        else {
          throw {
            checkactivity
          }
        }
      } catch (error) {
        console.error('Error approving activity:', error)
      }
    },

    async rejectActivity(...args) {
      try {
        const sendChange = new FormData();
        sendChange.append("status", 'reject');
        sendChange.append("status_remark", ['', 'null', null].includes(args[0].comment) ? '-' : args[0].comment);
        const checkactivity = await this.$http.patch(
          `/academic-service/main-activities/${args[0].data.id}/`,
          sendChange,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (checkactivity.status === 200) {
          const index = this.dataActivity.findIndex(
            (a) => a.id == args[0].data.id
          );
          this.dataActivity[index].status = args[0].textStatus
          this.selectedActivity.status = args[0].textStatus
          this.getAdminActivityList()
        }
        else {
          throw {
            checkactivity
          }
        }
      } catch (error) {
        console.error('Error rejecting activity:', error)
      }
    },

  },
}
</script>

<style scoped>
::v-deep(.table-bordered table) {
  border-collapse: collapse;
  width: 100%;
}

::v-deep(.table-bordered th),
::v-deep(.table-bordered td) {
  border: 1px solid #ddd;
  padding: 8px;
}

::v-deep(.table-bordered th) {
  background-color: #f5f5f5;
  font-weight: bold;
}

.action-buttons {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 6px;
  /* gap between buttons */
}

@media (max-width: 480px) {
  .action-buttons {
    flex-direction: column;
    /* stack vertically on small screens */
    align-items: flex-start;
  }
}

.highlight-end {
  background-color: #fff9c4;
  /* light yellow highlight */
  padding: 0px 0px;
  border-radius: 4px;
}
</style>
